"use client"
// PROTOTYPE — throwaway. Sign-in page redesign. See NOTES.md.
//
// Three variants of the sign-in page, switchable via ?variant=A|B|C on the real
// route, driven by the live page's real state and real handlers. Every element the
// live page carries is present in all three: wordmark, the searchParams message
// banner, the error banner, email + password, loading state, both OAuth providers,
// and the sign-up link.

import React from "react"
import { PrototypeSwitcher, type SignInViewProps, type VariantKey } from "./shell"
import { VariantA } from "./variant-a"
import { VariantB } from "./variant-b"
import { VariantC } from "./variant-c"

export { isVariantKey, type VariantKey, type SignInViewProps } from "./shell"

export function SignInPrototype({ variant, ...props }: SignInViewProps & { variant: VariantKey }) {
  return (
    <>
      {variant === "A" && <VariantA {...props} />}
      {variant === "B" && <VariantB {...props} />}
      {variant === "C" && <VariantC {...props} />}
      <PrototypeSwitcher current={variant} />
    </>
  )
}
